'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\tcolor: ', ';\n\tfont-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', ';\n\tline-height: ', ';\n'], ['\n\tcolor: ', ';\n\tfont-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', ';\n\tline-height: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\tdisplay: ', ';\n\tbackground: ', ';\n\tposition: absolute;\n\ttop: 100%;\n\t', ';\n\twidth: 100%;\n\tz-index: 10;\n\t& div.menuItem {\n\t\tbox-shadow: 0px 1px 0px ', ';\n\t\tborder-top: 1px solid ', ';\n\t\tborder-left: 1px solid ', ';\n\t\tborder-right: 1px solid ', ';\n\t\t&:hover {\n\t\t\tbackground: ', ';\n\t\t}\n\t}\n\t& div > a {\n\t\tcolor: ', ';\n\t\tfont-family: ', ';\n\t\tfont-weight: ', ';\n\t\tfont-size: ', ';\n\t\tline-height: ', ';;\n\t\tpadding: 15px;\n\t}\n\t@media (min-width: ', ') {\n\t\tmin-width: ', ';\n\t\tdisplay: ', ';\n\t}\n'], ['\n\tdisplay: ', ';\n\tbackground: ', ';\n\tposition: absolute;\n\ttop: 100%;\n\t', ';\n\twidth: 100%;\n\tz-index: 10;\n\t& div.menuItem {\n\t\tbox-shadow: 0px 1px 0px ', ';\n\t\tborder-top: 1px solid ', ';\n\t\tborder-left: 1px solid ', ';\n\t\tborder-right: 1px solid ', ';\n\t\t&:hover {\n\t\t\tbackground: ', ';\n\t\t}\n\t}\n\t& div > a {\n\t\tcolor: ', ';\n\t\tfont-family: ', ';\n\t\tfont-weight: ', ';\n\t\tfont-size: ', ';\n\t\tline-height: ', ';;\n\t\tpadding: 15px;\n\t}\n\t@media (min-width: ', ') {\n\t\tmin-width: ', ';\n\t\tdisplay: ', ';\n\t}\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n\tdisplay: ', ';\n\tbox-shadow: 0 5px 12px 0 #D83B9043;\n\tbackground: ', ';\n\tposition: absolute;\n\tpadding-top: 15px;\n\tpadding-bottom: 15px;\n\ttop: 100%;\n\t', ';\n\twidth: max-content;\n\tz-index: 10;\n\t> div {\n\t\tmargin-bottom: 2px;\n\t}\n\t& div.menuItem {\n\t\tcursor: pointer;\n\t\tpadding-left: 5px;\n\t\tpadding-right: 5px;\n\t\tmargin-left: 20px;\n\t\tmargin-right: 20px;\n\t\t&:hover {\n\t\t\tbox-shadow: 0 3px 12px #D83B904A;\n\t\t}\n\t}\n\t& div > a {\n\t\t', ';\n\t\tfont-weight: ', ';\n\t\tpadding: ', 'px;\n\t\t&:hover {\n\t\t\tfont-weight: ', ';\n\t\t}\n\t}\n'], ['\n\tdisplay: ', ';\n\tbox-shadow: 0 5px 12px 0 #D83B9043;\n\tbackground: ', ';\n\tposition: absolute;\n\tpadding-top: 15px;\n\tpadding-bottom: 15px;\n\ttop: 100%;\n\t', ';\n\twidth: max-content;\n\tz-index: 10;\n\t> div {\n\t\tmargin-bottom: 2px;\n\t}\n\t& div.menuItem {\n\t\tcursor: pointer;\n\t\tpadding-left: 5px;\n\t\tpadding-right: 5px;\n\t\tmargin-left: 20px;\n\t\tmargin-right: 20px;\n\t\t&:hover {\n\t\t\tbox-shadow: 0 3px 12px #D83B904A;\n\t\t}\n\t}\n\t& div > a {\n\t\t', ';\n\t\tfont-weight: ', ';\n\t\tpadding: ', 'px;\n\t\t&:hover {\n\t\t\tfont-weight: ', ';\n\t\t}\n\t}\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n\t', ';\n\toverflow: auto;\n\tmax-height: 80vh;\n'], ['\n\t', ';\n\toverflow: auto;\n\tmax-height: 80vh;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n\t@media (min-width: ', ') {\n\t\tposition: relative;\n\t\tcursor: ', ';\n\t}\n'], ['\n\t@media (min-width: ', ') {\n\t\tposition: relative;\n\t\tcursor: ', ';\n\t}\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: center;\n'], ['\n\tdisplay: flex;\n\talign-items: center;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n\tmargin: 0 ', 'px;\n'], ['\n\tmargin: 0 ', 'px;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n\twidth: 40px;\n\theight: 40px;\n\tborder: none;\n\toutline: none;\n\tbackground: none;\n\tpadding: 0;\n\tcursor: pointer;\n\tg {\n\t\tfill: ', ';\n\t}\n'], ['\n\twidth: 40px;\n\theight: 40px;\n\tborder: none;\n\toutline: none;\n\tbackground: none;\n\tpadding: 0;\n\tcursor: pointer;\n\tg {\n\t\tfill: ', ';\n\t}\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tborder: 0;\n\tbackground: none;\n\tpadding: 0;\n\toutline: none;\n\t', ';\n\tmargin: ', 'px;\n'], ['\n\tdisplay: flex;\n\talign-items: center;\n\tcursor: pointer;\n\tborder: 0;\n\tbackground: none;\n\tpadding: 0;\n\toutline: none;\n\t', ';\n\tmargin: ', 'px;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n\tdisplay: none;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: ', ';\n\tborder: 0;\n\tpadding: 0;\n\tcursor: pointer;\n\toutline: none;\n\tmin-width: 30px;\n\tmin-height: 30px;\n\tborder-radius: 50%;\n\t&:hover {\n\t\tbackground: ', ';\n\t}\n\t@media (min-width: ', ') {\n\t\tdisplay: flex;\n\t}\n'], ['\n\tdisplay: none;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground: ', ';\n\tborder: 0;\n\tpadding: 0;\n\tcursor: pointer;\n\toutline: none;\n\tmin-width: 30px;\n\tmin-height: 30px;\n\tborder-radius: 50%;\n\t&:hover {\n\t\tbackground: ', ';\n\t}\n\t@media (min-width: ', ') {\n\t\tdisplay: flex;\n\t}\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 0;\n\tcursor: auto;\n'], ['\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 0;\n\tcursor: auto;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n\tpadding: ', 'px;\n\tbackground: ', ';\n\tfont-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', 'px;\n\tline-height: ', 'px;\n    letter-spacing: ', ';\n\tcolor: ', ';\n\ttext-align: center;\n'], ['\n\tpadding: ', 'px;\n\tbackground: ', ';\n\tfont-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', 'px;\n\tline-height: ', 'px;\n    letter-spacing: ', ';\n\tcolor: ', ';\n\ttext-align: center;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n\tpadding-left: 15px;\n'], ['\n\tpadding-left: 15px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _link = require('../../../atoms/link');

var _link2 = _interopRequireDefault(_link);

var _arrow = require('../../../atoms/icons/arrow');

var _arrow2 = _interopRequireDefault(_arrow);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _getColor = require('../../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

var _sizes = require('../../../constants/sizes');

var _text = require('../../../constants/text');

var _colors = require('../../../constants/colors');

var _opacity = require('../../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _screenSize = require('../../../constants/screenSize');

var _mobileMenu = require('../../../atoms/icons/mobileMenu');

var _mobileMenu2 = _interopRequireDefault(_mobileMenu);

var _more = require('../../../atoms/icons/more');

var _more2 = _interopRequireDefault(_more);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _alignments = require('../../../constants/alignments');

var _auto = require('../../../atoms/icons/products/auto');

var _auto2 = _interopRequireDefault(_auto);

var _bundle = require('../../../atoms/icons/products/bundle');

var _bundle2 = _interopRequireDefault(_bundle);

var _commercial = require('../../../atoms/icons/products/commercial');

var _commercial2 = _interopRequireDefault(_commercial);

var _condo = require('../../../atoms/icons/products/condo');

var _condo2 = _interopRequireDefault(_condo);

var _home = require('../../../atoms/icons/products/home');

var _home2 = _interopRequireDefault(_home);

var _landlord = require('../../../atoms/icons/products/landlord');

var _landlord2 = _interopRequireDefault(_landlord);

var _motorcycle = require('../../../atoms/icons/products/motorcycle');

var _motorcycle2 = _interopRequireDefault(_motorcycle);

var _roommate = require('../../../atoms/icons/products/roommate');

var _roommate2 = _interopRequireDefault(_roommate);

var _tenant = require('../../../atoms/icons/products/tenant');

var _tenant2 = _interopRequireDefault(_tenant);

var _rv = require('../../../atoms/icons/products/rv');

var _rv2 = _interopRequireDefault(_rv);

var _pleasurecraft = require('../../../atoms/icons/products/pleasurecraft');

var _pleasurecraft2 = _interopRequireDefault(_pleasurecraft);

var _primaryButton = require('../../../atoms/buttons/primaryButton');

var _primaryButton2 = _interopRequireDefault(_primaryButton);

var _secondaryButton = require('../../../atoms/buttons/secondaryButton');

var _secondaryButton2 = _interopRequireDefault(_secondaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var menuLinkFontStyleStyles = (0, _styledComponents.css)(_templateObject, _colors.Colors.MenuTextColor, _text.TextSizes.HeaderFontFamily, _text.TextSizes.WeightSemiBold, _text.TextSizes.P2FontSize, _text.TextSizes.P2LineHeight);

var MenuListStyle = (0, _styledComponents.css)(_templateObject2, function (_ref) {
	var mobileOpen = _ref.mobileOpen;
	return mobileOpen ? 'block' : 'none';
}, _colors.Colors.MenuListBgColor, function (_ref2) {
	var align = _ref2.align;
	return align === 'left' ? 'left: 0' : 'right: 0';
}, _colors.Colors.StrokeLight, _colors.Colors.StrokeLight, _colors.Colors.StrokeLight, _colors.Colors.StrokeLight, _colors.Colors.StrokeVeryLight, _colors.Colors.MenuListColor, _text.TextSizes.HeaderFontFamily, _text.TextSizes.WeightSemiBold, _text.TextSizes.P2FontSize, _text.TextSizes.P2LineHeight, _screenSize.ScreenSize.lg, function (_ref3) {
	var alert = _ref3.alert;
	return alert ? '250px' : '220px';
}, function (_ref4) {
	var desktopOpen = _ref4.desktopOpen;
	return desktopOpen ? 'block' : 'none';
});

var LinkListStyle = (0, _styledComponents.css)(_templateObject3, function (_ref5) {
	var mobileOpen = _ref5.mobileOpen,
	    desktopOpen = _ref5.desktopOpen;
	return mobileOpen || desktopOpen ? 'block' : 'none';
}, _colors.Colors.LightMode, function (_ref6) {
	var align = _ref6.align;
	return align === 'left' ? 'left: 0' : 'right: 0';
}, menuLinkFontStyleStyles, _text.TextSizes.WeightMedium, function (_ref7) {
	var mobile = _ref7.mobile;
	return mobile ? 10 : 15;
}, _text.TextSizes.WeightMedium);

var MenuList = _styledComponents2.default.div(_templateObject4, function (_ref8) {
	var mode = _ref8.mode;
	return mode === 'link' ? LinkListStyle : MenuListStyle;
});

var MenuComponent = _styledComponents2.default.div(_templateObject5, _screenSize.ScreenSize.lg, function (_ref9) {
	var defaultIcon = _ref9.defaultIcon;
	return defaultIcon ? 'auto' : 'pointer';
});

var Flex = _styledComponents2.default.div(_templateObject6);

var TextWrapper = _styledComponents2.default.div(_templateObject7, (0, _getSize2.default)(_sizes.Sizes.xxs));

var MenuButton = _styledComponents2.default.button(_templateObject8, _colors.Colors.MenuButtonColor);

var MenuToggle = _styledComponents2.default.button(_templateObject9, menuLinkFontStyleStyles, function (_ref10) {
	var defaultIcon = _ref10.defaultIcon;
	return defaultIcon ? (0, _getSize2.default)(_sizes.Sizes.xs) : 0;
});

var MoreButton = _styledComponents2.default.div(_templateObject10, function (_ref11) {
	var desktopOpen = _ref11.desktopOpen;
	return desktopOpen ? _colors.Colors.MoreButtonColor : 'none';
}, _colors.Colors.MoreButtonHoverColor, _screenSize.ScreenSize.md);

var BackDrop = _styledComponents2.default.div(_templateObject11);

var MenuFooter = _styledComponents2.default.div(_templateObject12, (0, _getSize2.default)(_sizes.Sizes.xs), _colors.Colors.StrokeLight, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.WeightNormal, function (_ref12) {
	var secondaryStyle = _ref12.secondaryStyle;
	return secondaryStyle ? _text.TextSizes.P3FontSize : _text.TextSizes.P1FontSize;
}, function (_ref13) {
	var secondaryStyle = _ref13.secondaryStyle;
	return secondaryStyle ? _text.TextSizes.P3LineHeight : _text.TextSizes.P1LineHeight;
}, _text.TextSizes.ParagraphLetterSpacing, function (props) {
	if (props.disabled) return _colors.Colors.LightMode;
	if (props.error) return _colors.Colors.Error;
	return _colors.Colors.MenuFooter;
});

var MenuChildContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject13);

var Menu = function (_Component) {
	_inherits(Menu, _Component);

	function Menu() {
		var _ref14;

		var _temp, _this, _ret;

		_classCallCheck(this, Menu);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref14 = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref14, [this].concat(args))), _this), _this.state = {
			mobileOpen: false,
			desktopOpen: false,
			expandedItems: {}
		}, _this.clickMobileOpen = function () {
			_this.setState({ mobileOpen: _this.state.mobileOpen ? false : true });
		}, _this.setDesktopOpen = function (val) {
			return _this.setState({ desktopOpen: val });
		}, _this.handleClick = function (element) {
			_this.setState({ desktopOpen: false, mobileOpen: false, expandedItems: {} });
			element.clickEvent();
		}, _this.handleMobileClick = function (element) {
			var e = JSON.parse(JSON.stringify(_this.state.expandedItems));
			e[element.code] = !e[element.code];
			_this.setState({ expandedItems: e });
			element.clickEvent();
		}, _this.getIcon = function (code) {
			var icon = null;

			switch (code) {
				case "auto":
					icon = _react2.default.createElement(_auto2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
				case "bundle":
					icon = _react2.default.createElement(_bundle2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
				case "commercial":
					icon = _react2.default.createElement(_commercial2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
				case "condo":
					icon = _react2.default.createElement(_condo2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
				case "home":
					icon = _react2.default.createElement(_home2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
				case "landlord":
					icon = _react2.default.createElement(_landlord2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
				case "motorcycle":
					icon = _react2.default.createElement(_motorcycle2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
				case "pleasurecraft":
					icon = _react2.default.createElement(_pleasurecraft2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
				case "roommate":
					icon = _react2.default.createElement(_roommate2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
				case "rv":
					icon = _react2.default.createElement(_rv2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
				case "tenant":
					icon = _react2.default.createElement(_tenant2.default, { color: _colors.Colors.StrokeVeryDark });
					break;
			}

			return icon;
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Menu, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var mode = this.props.mode ? this.props.mode === 'link' ? 'link' : this.props.mode === 'button' ? 'button' : 'menu' : 'menu';

			return _react2.default.createElement(
				MenuComponent,
				{
					defaultIcon: !this.props.text,
					className: this.props.className,
					onMouseEnter: function onMouseEnter() {
						return _this2.props.behavior !== 'click' && _this2.setDesktopOpen(true);
					},
					onMouseLeave: function onMouseLeave() {
						return _this2.props.behavior !== 'click' && _this2.setDesktopOpen(false);
					} },
				this.props.mobile ? _react2.default.createElement(
					MenuButton,
					{ onClick: this.clickMobileOpen },
					this.state.mobileOpen ? _react2.default.createElement(_mobileMenu2.default, { hover: true }) : _react2.default.createElement(_mobileMenu2.default, null)
				) : _react2.default.createElement(
					Flex,
					null,
					_react2.default.createElement(
						MenuToggle,
						{
							defaultIcon: !this.props.text,
							onClick: function onClick() {
								return _this2.props.behavior === 'click' && _this2.setDesktopOpen(!_this2.state.desktopOpen);
							} },
						mode === 'button' && _react2.default.createElement(_primaryButton2.default, { text: this.props.text, left: _sizes.Sizes.xs, right: _sizes.Sizes.xs }),
						mode !== 'button' && !this.props.text && _react2.default.createElement(
							MoreButton,
							{ desktopOpen: this.state.desktopOpen },
							_react2.default.createElement(_more2.default, null)
						),
						mode !== 'button' && this.props.text && _react2.default.createElement(
							TextWrapper,
							null,
							this.props.text
						),
						mode !== 'button' && this.props.text && _react2.default.createElement(_arrow2.default, { direction: 'down', color: _colors.Colors.MenuTextColor })
					),
					this.props.behavior === 'click' && this.state.desktopOpen && _react2.default.createElement(BackDrop, { onClick: function onClick() {
							return _this2.setDesktopOpen(false);
						} })
				),
				_react2.default.createElement(
					MenuList,
					{
						mode: mode,
						mobile: this.props.mobile, mobileOpen: this.state.mobileOpen,
						desktopOpen: this.state.desktopOpen,
						align: this.props.align,
						color: this.props.color },
					_react2.default.createElement(
						_react2.default.Fragment,
						null,
						this.props.elements.map(function (element, i) {
							var children = !_this2.props.subMenu && element.elements && element.elements;
							return _react2.default.createElement(
								_react2.default.Fragment,
								{ key: i },
								!children && _react2.default.createElement(
									_container2.default,
									{
										inline: true,
										verticalAlignment: _alignments.Alignments.center,
										className: 'menuItem',
										clickEvent: function clickEvent() {
											return !children && _this2.handleClick(element);
										},
										color: _this2.props.subMenu && !_this2.props.desktop && _colors.Colors.StrokeVeryLight
									},
									_this2.props.subMenu && _this2.getIcon(element.code),
									_react2.default.createElement(_link2.default, {
										key: 'menuItem_' + element.code + '_' + i,
										text: element.text,
										textAlign: _this2.state.mobileOpen ? 'center' : _this2.props.align || 'right'
									})
								),
								children && _react2.default.createElement(
									_container2.default,
									{
										inline: true,
										verticalAlignment: _alignments.Alignments.center,
										className: 'menuItem',
										clickEvent: function clickEvent() {
											return _this2.handleMobileClick(element);
										},
										color: _this2.state.expandedItems[element.code] ? _colors.Colors.StrokeVeryLight : undefined
									},
									_this2.props.subMenu && _this2.getIcon(element.code),
									_react2.default.createElement(_link2.default, {
										key: 'menuItem_' + element.code + '_' + i,
										text: element.text,
										textAlign: _this2.state.mobileOpen ? 'center' : _this2.props.align || 'right'
									}),
									_react2.default.createElement(_arrow2.default, { direction: _this2.state.expandedItems[element.code] ? 'up' : 'down', color: _colors.Colors.MenuTextColor })
								),
								children && _this2.state.expandedItems[element.code] && children.map(function (child, j) {
									return _react2.default.createElement(
										MenuChildContainer,
										{
											key: j,
											inline: true,
											verticalAlignment: _alignments.Alignments.center,
											className: 'menuItem',
											clickEvent: function clickEvent() {
												return _this2.handleClick(child);
											},
											color: _colors.Colors.StrokeVeryLight
										},
										_this2.getIcon(child.code),
										_react2.default.createElement(_link2.default, {
											key: 'menuItem_' + element.code + '_' + child.code + '_' + j,
											text: child.text,
											textAlign: _this2.state.mobileOpen ? 'center' : _this2.props.align || 'right'
										})
									);
								})
							);
						})
					),
					this.props.footer && _react2.default.createElement(
						MenuFooter,
						{ secondaryStyle: true },
						this.props.footer
					)
				)
			);
		}
	}]);

	return Menu;
}(_react.Component);

exports.default = Menu;